import type { FC } from 'react';

import styled from 'styled-components';

import { colorsPalettes, setFontVariant } from '@similarweb/styles';

import type { ButtonProps } from '../../../../components/Button';
import { Button } from '../../../../components/Button';
import { HEADER_HEIGHT } from '../../../../components/Header/styles';
import { AssetsService } from '../../../../services/AssetsService';

export const StyledOnboardingOverlay = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: calc(100vh - ${HEADER_HEIGHT}px - 8px);
  border-radius: 32px 32px 0 0px;
  background-color: ${colorsPalettes.bluegrey[100]};
  box-shadow: 0px 0px 15px 2px rgba(162, 181, 209, 0.4);
  transform: translateY(100%);
  z-index: 1;
  padding: 16px 24px;
  background-image: url(${AssetsService.assetUrl('images/onboarding-bg.png')});
  background-repeat: no-repeat;
  background-position-x: right;
  background-size: contain;

  display: flex;
  flex-wrap: wrap;
  align-items: center;
  align-content: flex-start;
  overflow: auto;
`;

export const StyledOnboardingContent = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  align-content: flex-start;
  min-height: 650px;
`;

export const StyledContinueButton = styled<FC<ButtonProps & { smallOffset?: boolean }>>(Button)`
  margin: ${({ smallOffset }) => (smallOffset ? '8px auto 0' : '42px auto 0')};
`;

export const StyledStepsLeft = styled.span`
  ${setFontVariant('sectionTitle', colorsPalettes.carbon[400])};
  line-height: 20px;
  margin-top: 8px;
  width: 100%;
  text-align: center;
`;

export const StyledMetricsWrapper = styled.div`
  padding-right: 12px;
`;
